var lastScrollTop = 0,
  lastScrollDir = 0,
  upgradeLoading = !1,
  triggerCustomCartDataLoading = !1;
(window.starRatings = {}), (window.reviewsFetched = !1), (window.review_callbacks = []);
try {
    (localStorage.getItem("admin-release") == "admin-release" || window.location.href.indexOf("myshopify") > -1 || window.location.href.indexOf("oseid") > -1 || window.location.href.indexOf("admin-release") > -1) &&
      (localStorage.setItem("admin-release", "admin-release"), document.getElementById("fs-release-overlay").remove(), setTimeout(() => UnlockScroll(), 500));
} catch {
  console.error("release disable fail");
}
document.addEventListener("rebuy:smartcart.init", (event) => {
  ConfigureCartCount();
}),
  document.addEventListener("rebuy:smartcart.show", (event) => {
    ConfigureCartCount();
  }),
  document.addEventListener("rebuy:cart.change", (event) => {
    ConfigureCartCount();
  }),
  setTimeout(() => {
    window.location.href.indexOf("admin=1") > -1 && ($("body").addClass("admin-view"), $("#header-countdown").show());
  }, 1e3);
function ConfigureCartCount() {
  var itemCount = Rebuy.Cart.itemCount(),
    lineCount = Rebuy.Cart.lineCount();
  $("#cart-count-mb").text(itemCount),
    $("#cart-count-dt").text(itemCount),
    setTimeout(() => {
      $("#cart-count-mb").show(), $("#cart-count-dt").show();
    }, 100);
}
$(".f_filter").on("click", () => {
  setTimeout(() => {
    $("div[data-stars]").each((i, el) => {
      getStarRating($(el).attr("data-prefix"), $(el).attr("data-tag"), $(el).attr("data-star-colour"), $(el).attr("data-star-size"));
    });
  }, 150);
});
function refreshStars() {
  setTimeout(() => {
    $("div[data-stars]").each((i, el) => {
      getStarRating($(el).attr("data-prefix"), $(el).attr("data-tag"), $(el).attr("data-star-colour"), $(el).attr("data-star-size"));
    });
  }, 500);
}
setTimeout(() => {
  refreshStars();
}, 1e3),
  setInterval(() => {
    refreshStars();
  }, 1e4);
async function rateReview(reviewId, rating) {
  var resp = await fetch(`https://arrae-yotpo-4c7d6545d621.herokuapp.com/api/v1/yotpo/vote/${reviewId}/${rating}`, { method: "POST", headers: { Accept: "application/json", "Content-Type": "application/json" } }),
    content2 = await resp.json();
  console.log(content2), (window.starRatings = content2), localStorage.setItem("cached-reviews", JSON.stringify(content2)), localStorage.setItem("last-cached-reviews", new Date().getTime()), alert("rating complete");
  try {
    await getReviews();
  } catch (ex) {
    console.error(ex);
  }
}
async function getAllReviews() {
  try {
    window.loadingReviews = !0;
    var reviews = localStorage.getItem("cached-reviews"),
      lastChecked = localStorage.getItem("last-cached-reviews");
    if (((lastChecked == null || new Date().getTime() - Number.parseInt(lastChecked) > 36e5) && (reviews = null), reviews != null && reviews != "{}" && reviews != "")) {
      (window.starRatings = JSON.parse(reviews)), console.warn("used cached reviews"), (window.reviewsFetched = !0), renderRegisteredStars();
      return;
    }
    try {
      var resp = await fetch("https://arrae-yotpo-4c7d6545d621.herokuapp.com/api/v1/yotpo/all-stars", { method: "GET", headers: { Accept: "application/json", "Content-Type": "application/json" } }),
        rating_content = await resp.json();
      try {
        localStorage.setItem("cached-reviews", JSON.stringify(rating_content)), localStorage.setItem("last-cached-reviews", new Date().getTime());
      } catch (ex) {
        console.error("failed to locally cache reviews", ex), console.warn("tried to cache", rating_content, JSON.stringify(rating_content).length);
      }
      (window.starRatings = rating_content),
        (window.reviewsFetched = !0),
        (window.loadingReviews = !1),
        window.review_callbacks.forEach((c) => {
          c();
        }),
        (window.review_callbacks = []);
    } catch (ex) {
      console.error("fetch all stars api call failed", ex);
    }
  } catch (ex) {
    console.error("getAllReviews FAILED", ex);
  }
}
getAllReviews();
async function CacheAllResults() {
  var resp = await fetch("https://arrae-yotpo-4c7d6545d621.herokuapp.com/api/v1/yotpo/cache-all-stars", { method: "GET", headers: { Accept: "application/json", "Content-Type": "application/json" } });
  return alert("cache complete"), resp.json();
}
function registerStars(prefix, tag, colour = "#404040", starSize = 18) {
  window.allStarElements == null && (window.allStarElements = []), window.allStarElements.push({ prefix, tag, colour, starSize, element: $(`.${prefix}_${tag}_rating_stars`) });
}
function renderRegisteredStars() {
  window.allStarElements != null &&
    window.allStarElements.forEach((e) => {
      RenderStarRating(e.prefix, e.tag, e.colour, e.starSize);
    });
}
function RenderStarRating(prefix, tag, colour = "#404040", starSize = 18) {
  try {
    (content = window.starRatings[tag]),
      (content == null || content.starRating <= 3) && (content.starRating = 4.5),
      (content == null || content.reviewCount <= 200) && (content.reviewCount = Math.floor(Math.random() * 101) + 300),
      $(`.${prefix}_${tag}_rating_stars`).starRating({ totalStars: 5, initialRating: content.starRating, starSize, emptyColor: "lightgray", activeColor: colour, useGradient: !1, readOnly: !0 }),
      $(`.${prefix}_${tag}_rating_stars`).starRating("setRating", content.starRating, !1),
      $(`.${prefix}_${tag}_rating_text`).text(`${content.reviewCount} Reviews`);
  } catch (ex) {
    ($(`.${prefix}_${tag}_rating_stars`).length > 0 || $(`.${prefix}_${tag}_rating_text`).length > 0) && console.error("fAILED TO RENDER STAR", tag, ex);
  }
}
async function getStarRating(prefix, tag, colour = "#404040", starSize = 18) {
  if (tag != null && tag != null) {
    if (tag == "") {
      $(`.${prefix}_${tag}_rating_text`).text("");
      return;
    }
    var content2 = {};
    if (window.starRatings[tag] == null) {
      review_callbacks.push(() => {
        RenderStarRating(prefix, tag, colour, starSize);
      }),
        window.loadingReviews || getAllReviews();
      return;
      var resp;
    } else RenderStarRating(prefix, tag, colour, starSize);
  }
}
function CustomReset() {
  document.querySelector(".cart-button-checkout-text")?.classList.remove("hide"), document.querySelector(".cart-button-checkout-spinner")?.classList.add("hide");
}
function CustomListen() {
  document.querySelectorAll("button.secondary.qty-plus").forEach((item) => {
    item.addEventListener("click", function (e) {
      document.querySelectorAll(".quantity-controls button.qty-plus:not(.secondary)").forEach((_i) => {
        _i.click();
      });
    });
  }),
    document.querySelectorAll("button.secondary.qty-minus").forEach((item) => {
      item.addEventListener("click", function (e) {
        document.querySelectorAll(".quantity-controls button.qty-minus:not(.secondary)").forEach((_i) => {
          _i.click();
        });
      });
    });
}
function CustomQuantityChanged(variant_id, e, main_price, var_price) {
  (window.product.CompareAtPrice = `${getCurrencySymbol()}${var_price / 100}`), main_price == var_price && (window.product.CompareAtPrice = `${getCurrencySymbol()}0.00`);
  for (var x = document.getElementsByClassName(e.target.className), i = 0; i < x.length; i++) x[i].checked = !0;
  (window.product.Price = `${getCurrencySymbol()}${main_price / 100}`), custom_variant_change(variant_id);
}
function recalcPrice(newVal, variant_id) {
  if (!(typeof window.product > "u" || window.product == null)) {
    for (var bp = parseFloat(window.product.Price.replace(getCurrencySymbol(), "")), newPrice = bp * newVal, quant = document.getElementsByClassName("quantity-selector"), i = 0; i < quant.length; i++) quant[i].value = newVal;
    for (var ptu = document.getElementsByClassName("update_price_field"), i = 0; i < ptu.length; i++) ptu[i].innerHTML = `<span class="money" data-variant-id="${variant_id}">${getCurrencySymbol()}${newPrice.toFixed(2)}</span>`;
    for (var cptu = document.querySelectorAll(".compare-at-price.js"), i = 0; i < cptu.length; i++) cptu[i].innerHTML = `<span class="money" data-variant-id="${variant_id}"></span>`;
    if (window.product.CompareAtPrice == "\xA30.00") for (var cptu = document.querySelectorAll(".compare-at-price.js"), i = 0; i < cptu.length; i++) cptu[i].innerHTML = '<span class="money"></span>';
    else
      for (var compAtPrice = parseFloat(window.product.CompareAtPrice.replace(getCurrencySymbol(), "")), newCompPrice = compAtPrice * newVal, cptu = document.querySelectorAll(".compare-at-price.js"), i = 0; i < cptu.length; i++)
        cptu[i].innerHTML = `<span class="money" data-variant-id="${variant_id}">${getCurrencySymbol()}${newCompPrice.toFixed(2)}</span>`;
  }
}
function DisplayPrice(newPrice, newCompPrice, quantity = 1, product_id) {
  newPrice *= quantity;
  for (var igMultiplier = newPrice / newCompPrice, ptu = document.getElementsByClassName("update_price_field"), i = 0; i < ptu.length; i++)
    ptu[i].innerHTML = `<span class="money igPrice" data-product-id="${product_id}" ${igMultiplier != NaN ? "data-price-multiplier='" + igMultiplier * quantity + "'" : ""}>${getCurrencySymbol()}${newPrice.toFixed(2)}</span>`;
  if (newCompPrice == null || newCompPrice.toString().endsWith("0.00") || newCompPrice.toString() == newPrice.toString())
    for (var cptu = document.querySelectorAll(".compare-at-price.js"), i = 0; i < cptu.length; i++) cptu[i].innerHTML = `<span class="money" data-product-id="${product_id}"></span>`;
  else
    for (var cptu = document.querySelectorAll(".compare-at-price.js"), i = 0; i < cptu.length; i++)
      cptu[i].innerHTML = `<span class="money igPrice" data-product-id="${product_id}" data-price-multiplier="${quantity}">${getCurrencySymbol()}${newCompPrice.toFixed(2)}</span>`;
}
function getCurrencySymbol() {
  const locale = window.Shopify.locale,
    currency = window.Shopify.currency.active;
  return (0).toLocaleString(locale, { style: "currency", currency, minimumFractionDigits: 0, maximumFractionDigits: 0 }).replace(/\d/g, "").trim();
}
function custom_variant_change(variant_id) {
  var qtyInput = document.getElementById("quantity"),
    val = parseInt(qtyInput.value.toString(), 10),
    variantInput = document.getElementById("product_id");
  (variantInput.value = variant_id), recalcPrice(val, variant_id);
}
CustomListen(),
  CustomReset(),
  ConfigureRecharge(),
  ConfigureSubAndSave();
function ConfigureSubAndSave() {
  console.log("ConfigureSubAndSave"),
    $(".selected_selling_plan:not(.__soldout__, .__oneplan__)").on("click", (e) => {
      var product_form_id = $(e.currentTarget).attr("data-form");
      $(`.product-form:not(#${product_form_id}) .selling_plan_options`).addClass("closed"),
        $(`.product-form:not(#${product_form_id}) .selected_selling_plan`).removeClass("open"),
        $(e.currentTarget).hasClass("open")
          ? ($(e.currentTarget).removeClass("open"), $(`#${product_form_id} .selling_plan_options`).addClass("closed"))
          : ($(e.currentTarget).addClass("open"), $(`#${product_form_id} .selling_plan_options`).removeClass("closed"));
    });
}
function SellingPlanRender() {
  $(".selected_selling_plan").each((i, e) => {
    var productFormId = $(e).attr("data-form-id"),
      productCard = $(e).attr("data-for"),
      productId = $(e).attr("data-product"),
      variantId = $(e).attr("data-variant"),
      updatingIndex = window._product_options[`${productFormId}`][`${productCard}`].findIndex((e2, i2) => e2.product == productId && e2.variant == variantId);
    if (updatingIndex >= 0) {
      var product = window._product_options[`${productFormId}`][`${productCard}`][updatingIndex];
      console.log(product),
        $(`#${productFormId}.product-form .selected_selling_plan`).html(""),
        $(`#${productFormId}.product-form .selected_selling_plan`).append(product.html),
        $(`#${productFormId}.product-form .selling_plan_options`).html(""),
        window._product_options[`${productFormId}`][`${productCard}`].forEach((e2, i2) => {
          i2 != updatingIndex && $(`#${productFormId}.product-form .selling_plan_options`).append(window._product_options[`${productFormId}`][`${productCard}`][i2].html);
        }),
        $(`#${productFormId}.product-form input#selling_plan`).val(product.sellingPlanId),
        $(`#${productFormId}.product-form input#id`).val(product.variant),
        $(`#${productFormId}.product-form input#product-id`).val(product.product);
    }
  });
}
function SellingPlanChange(event) {
  var $parent = $(event).parent(".selected_selling_plan");
  if ($parent.attr("data-sub-count") != 1 && !($parent.length > 0)) {
    var productFormId = $(event).attr("data-form-id"),
      productCard = $(event).attr("data-for"),
      productId = $(event).attr("data-product"),
      variantId = $(event).attr("data-variant"),
      updatingIndex = window._product_options[`${productFormId}`][`${productCard}`].findIndex((e, i) => e.product == productId && e.variant == variantId);
    if (updatingIndex >= 0) {
      var product = window._product_options[`${productFormId}`][`${productCard}`][updatingIndex];
      console.log(product),
        $(`#${productFormId}.product-form .selected_selling_plan`).html(""),
        $(`#${productFormId}.product-form .selected_selling_plan`).append(product.html),
        $(`#${productFormId}.product-form .selling_plan_options`).html(""),
        window._product_options[`${productFormId}`][`${productCard}`].forEach((e, i) => {
          i != updatingIndex && $(`#${productFormId}.product-form .selling_plan_options`).append(window._product_options[`${productFormId}`][`${productCard}`][i].html);
        }),
        $(`#${productFormId}.product-form input#selling_plan`).val(product.sellingPlanId),
        $(`#${productFormId}.product-form input#id`).val(product.variant),
        $(`#${productFormId}.product-form input#product-id`).val(product.product);
    }
    $(`#${productFormId}.product-form .selling_plan_options`).addClass("closed"), $(`#${productFormId}.product-form .selected_selling_plan`).removeClass("open");
  }
}
function ConfigureRecharge() {
  console.log("WINDOW LOAD"),
    window.location.href.indexOf("recurring/portal") > 0 &&
      (console.log("ON PAGE"),
      setTimeout(() => {
        if (
          (console.log("DO THING"),
          $("._15b7gxl0.recharge-component-schedule-item").prepend(
            "<div class='bootstrap'><p class='d-block mb-2 fs-6'>Changes to your order may take a moment to reflect correct pricing. Please refresh after making any updates.</p></div>"
          ),
          $("._15b7gxl0.recharge-component-schedule-item").prepend(
            "<div class='bootstrap'><p class='d-block mb-2 fs-6'>Note: Membership pricing is specific to individual active subscriptions. Making changes to your current subscription such as removing or swapping products may result in loss of loyalty perks and membership discounts.</p></div>"
          ),
          !(window.ReCharge.charges[0].discount_codes.length > 0))
        )
          return;
        const DISCOUNTCODE = window.ReCharge.charges[0].discount_codes[0].code;
        console.log("render discount", DISCOUNTCODE),
          $('div._15b7gxl0[data-testid="order-summary-wrapper"]').append(
            `<div class='bootstrap'><div class='d-flex align-items-center'><div class=''><span class='fs-6'>Discount</span></div><div class='d-flex'><div class='ms-1 d-flex gap-1 align-items-center'><div class='d-flex'><span class='_15b7gxl0 _17o99wpuf _17o99wpvc _17o99wpw6 _17o99wptf _17o99wphu _17o99wp3 _17o99wpli recharge-pill _16omeme0 v5g8zj0 v5g8zj2'><span role='heading' aria-level='4' class='_15b7gxl0 recharge-heading recharge-heading-h4 _1brvylo0 _1brvylo7 _1brvylo8 fw-bold fw-bold'>${DISCOUNTCODE}</span></span></div><div class='_15b7gxl0'><span role='button' tabindex='0' class='_15b7gxl0 _16omeme0 _1qyrsef0 _1qyrsef2 _1qyrsef5 _1qyrsef7 _1qyrsef9 _1qyrsefa'><div class='_15b7gxl0 _17o99wpw9 _17o99wpti _17o99wpuf _17o99wpvc _17o99wpmr _17o99wphx _17o99wplo _17o99wp0 recharge-icon n89mvw0 n89mvw8'><svg viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg' width='16' height='16'><g stroke='currentColor' stroke-width='1.2' stroke-linecap='round' stroke-linejoin='round'><path d='M1.143 4h13.714M2.857 4h10.286v10.286A1.143 1.143 0 0 1 12 15.429H4a1.143 1.143 0 0 1-1.143-1.143V4ZM5.143 4v-.571a2.857 2.857 0 0 1 5.714 0V4M6.286 7.43v4.573M9.714 7.43v4.573'></path></g></svg></div><div style='border: 0px; clip: rect(0px, 0px, 0px, 0px); clip-path: inset(50%); height: 1px; margin: -1px; overflow: hidden; padding: 0px; position: absolute; width: 1px; white-space: nowrap;'>Remove</div></span></div></div></div></div></div>`
          );
      }, 1e4));
}
function ShowLoading() {
  (document.getElementById("loadingOverlay").style.display = "flex"), LockScroll();
}
function HideLoading() {
  (document.getElementById("loadingOverlay").style.display = "none"), UnlockScroll();
}
function LockedScroll() {
  return $("html").hasClass("whitebox-open");
}
function LockScroll() {
  var y = -scrollY;
  $("html").addClass("whitebox-open"), $(".whitebox-open body").css("top", y);
}
function UnlockScroll() {
  var y = Number.parseFloat($(".whitebox-open body").css("top"));
  (y = y * -1),
    $(".whitebox-open body").css("top", null),
    $("html").removeClass("whitebox-open"),
    window.scrollTo({ top: y, left: 0, behavior: "instant" }),
    setTimeout(() => {
      window.scrollTo({ top: y, left: 0, behavior: "instant" });
    }, 10);
}
function SnippetProductUpdate(productFormId, productId, variantId, sellingPlanId, sellingPlanText) {
  var quantity = 1;
  $(`#${productFormId} input#product_id`).val(variantId),
    $(`#${productFormId}  input#quantity`).val(sellingPlanId == null ? quantity : 1),
    $(`#${productFormId}  input[name="product-id"]`).val(productId),
    $(`#${productFormId}  input[name="selling_plan"]`).val(sellingPlanId),
    $(`#${productFormId}  input#option-0`).val(sellingPlanText),
    $(`#${productFormId}  input#purchase_type`).val(sellingPlanId == null ? "one-time" : "subscription");
}
$("body").on("click", ".main-product__popup-modal-content-wrapper .size-guide-popup-tabs ul li", function (e) {
  e.preventDefault(),
    $(this).hasClass("tab-active") ||
      ($(".main-product__popup-modal-content-wrapper .size-guide-popup-tabs ul li").toggleClass("tab-active"), $(".main-product__popup-modal-content-wrapper .size-guide-popup-content > div").toggleClass("content-active"));
});
$("body").on("click", ".main-product__popup-modal-content-wrapper .size-guide-popup-measurements ul li", function (e) {
  e.preventDefault(),
    $(this).hasClass("measurement-active") ||
      ($(".main-product__popup-modal-content-wrapper .size-guide-popup-measurements ul li").toggleClass("measurement-active"),
      $(".main-product__popup-modal-content-wrapper .size-guide-popup-content .measurement-conversion").toggleClass("m-in m-cm"));
});
$(document).on("click", "#size-guide-popup .size-guide-popup-tabs ul li", function (e) {
  e.preventDefault(), $(this).hasClass("tab-active") || ($("#size-guide-popup .size-guide-popup-tabs ul li").toggleClass("tab-active"), $("#size-guide-popup .size-guide-popup-content > div").toggleClass("content-active"));
});
$(document).on("click", "#size-guide-popup .size-guide-popup-measurements ul li", function (e) {
  e.preventDefault(),
    $(this).hasClass("measurement-active") ||
      ($("#size-guide-popup .size-guide-popup-measurements ul li").toggleClass("measurement-active"), $("#size-guide-popup .size-guide-popup-content .measurement-conversion").toggleClass("m-in m-cm"));
});